import * as Twilio from 'twilio-sync'
import get from 'lodash/get'
import { ParticipantInformationInterface } from '../../dataStore/reducers/docs/syncUi/types'
import docUpdateAndLog from '../docUpdateAndLog'

/** Determine if the participant exists in the doc. If it does, update the information, otherwise add it to the array */
export default async function setParticipantInformation (uiDoc: Twilio.SyncDocument, participantInformation: ParticipantInformationInterface): Promise<boolean> {


  let participantInformationArray = [...get(uiDoc.data, 'participantInformation', [])]
  const entryExists = participantInformationArray.some(({ id }) => id === participantInformation.id)

  if (entryExists) {

    participantInformationArray = participantInformationArray
      .map(participant =>
        participant.id === participantInformation.id
          ? participantInformation
          : participant
      )

  }
  else {

    participantInformationArray.push(participantInformation)

  }

  return docUpdateAndLog(uiDoc, { participantInformation: participantInformationArray }, 'uiDoc')

}
